import React from 'react'
import { useConfirmDialog, useDbRestore, useError } from '@ztechapps/common.hook'
import { BusyButton } from '@ztechapps/webui.button'
import { ShowIf } from '@ztechapps/webui.util'
import { useDbRestoreContext } from './Context'

export type DbRestoreButtonProps = { variant?: React.ComponentProps<typeof BusyButton>['variant'] }

export const DbRestoreButton = ({ variant = 'warning' }: DbRestoreButtonProps) => {
  const [onRestore, { loading, error }] = useDbRestore()
  const { enabled, onStarted } = useDbRestoreContext()
  const { confirm } = useConfirmDialog({
    title: 'Restore Database',
    text: 'This replaces the database with the latest production backup and cannot be undone. You will be signed out when it finishes.',
    buttons: { confirm: { text: 'Restore' } },
  })

  useError(error)

  const onClick = async () => {
    await confirm(async () => {
      const result = await onRestore()
      if (result?.state) onStarted(result)
    })
  }

  return (
    <ShowIf condition={enabled}>
      <BusyButton
        text="Restore Db"
        variant={variant}
        isBusy={loading}
        onClick={onClick}
        title="You are NOT in PRODUCTION, so you can restore the database."
      />
    </ShowIf>
  )
}
